import { render } from "./IconDocumentBlue.vue?vue&type=template&id=4a9cc924"
const script = {}
script.render = render

export default script